import { URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';

import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/toPromise';

import { AlterMonitoramentoAvaliacao } from '../../model';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../seguranca/auth.service';

export class AlterMonitoramentoAvaliacaoFiltro {
  usuarioAvaliou;
	usuarioSubmeteu;
	versaoPlano;
	monitoramentoAvaliacao;
	pthpId;
	tipoAlteracao;
	statusAlteracao;

  pagina = 0;
  itensPorPagina = 20;
}

@Injectable()
export class AlterMonitoramentoAvaliacaoService {

  url: string;

  constructor(private http: AuthHttp,
    public auth: AuthService, ) {
    this.url = `${environment.apiUrl}/alter-monitoramento-avaliacao`;
  }

  pesquisar(filtro: AlterMonitoramentoAvaliacaoFiltro): Promise<any> {
    const params = new URLSearchParams();

    params.set('page', filtro.pagina.toString());
    params.set('size', filtro.itensPorPagina.toString());

    if (filtro.usuarioAvaliou) {
      params.set('usuarioAvaliou', filtro.usuarioAvaliou);
    }
    if (filtro.usuarioSubmeteu) {
      params.set('usuarioSubmeteu', filtro.usuarioSubmeteu);
    }
    if (filtro.versaoPlano) {
      params.set('versaoPlano', filtro.versaoPlano);
    }
    if (filtro.monitoramentoAvaliacao) {
      params.set('monitoramentoAvaliacao', filtro.monitoramentoAvaliacao);
    }
    if (filtro.tipoAlteracao) {
      params.set('tipoAlteracao', filtro.tipoAlteracao);
    }
    if (filtro.statusAlteracao) {
      params.set('statusAlteracao', filtro.statusAlteracao);
    }
    if (filtro.pthpId) {
      params.set('pthpId', filtro.pthpId);
    }

    return this.http.get(`${this.url}`, { search: params })
      .toPromise()
      .then(response => {
        const responseJson = response.json();
        const dado = responseJson.content;

        const resultado = {
          dado,
          total: responseJson.totalElements
        };
        return resultado;

      })
  }

  listarTodos(): Promise<any> {
    return this.http.get(this.url)
      .toPromise()
      .then(response => response.json().content);
  }

  excluir(codigo: number): Promise<void> {
    return this.http.delete(`${this.url}/${codigo}`)
      .toPromise()
      .then(() => null);
  }

  adicionar(entidade: AlterMonitoramentoAvaliacao): Promise<AlterMonitoramentoAvaliacao> {
    return this.http.post(this.url, JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json());
  }

  atualizar(entidade: AlterMonitoramentoAvaliacao): Promise<AlterMonitoramentoAvaliacao> {

    return this.http.put(`${this.url}/${entidade.id}`,
      JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json() as AlterMonitoramentoAvaliacao);
  }

  avaliar(entidade: AlterMonitoramentoAvaliacao): Promise<AlterMonitoramentoAvaliacao> {
    return this.http.put(`${this.url}/avaliar`,
      JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json() as AlterMonitoramentoAvaliacao);
  }

  alterarAvaliacao(entidade: AlterMonitoramentoAvaliacao): Promise<AlterMonitoramentoAvaliacao> {
    return this.http.put(`${this.url}/alterar-avaliacao`,
      JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json() as AlterMonitoramentoAvaliacao);
  }

  buscarPorCodigo(codigo: number): Promise<AlterMonitoramentoAvaliacao> {
    return this.http.get(`${this.url}/${codigo}`)
      .toPromise()
      .then(response => {
        const entidade = response.json() as AlterMonitoramentoAvaliacao;
        return entidade;
      });
  }

}
